<dp-section-form-header [section]="section"></dp-section-form-header>

<dp-header [rightActions]="rightActions" [leftActions]="leftActions" [moreMenuGroups]="moreMenuGroups"></dp-header>

<dp-search
    [hidden]="!showSearch"
    [searchAvailableOptions]="searchAvailableOptions"
    [showSavedSearchButtons]="false"
    [searchConfig]="searchConfig"
    (searchInfo)="sendSearch($event)"
    (clearResults)="clearSearch()"
    (hide)="hideSearch()"
></dp-search>